import { render, staticRenderFns } from "./uploadIcon.vue?vue&type=template&id=38ea8c88&"
import script from "./uploadIcon.vue?vue&type=script&lang=js&"
export * from "./uploadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports